export const totalAtv = ({ rows }) => {
  let total_taxable_vat = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(
        i.taxable_vat?.replace
          ? i.taxable_vat?.replace(',', '.')
          : i.taxable_vat,
      ),
    0,
  );
  let total_receipts = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(
        i.receipts?.replace ? i.receipts?.replace(',', '.') : i.receipts,
      ),
    0,
  );

  let atv = 0;
  if (total_taxable_vat > 0 && total_receipts > 0) {
    atv = total_taxable_vat / total_receipts;
  }
  atv = atv.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  return atv.replace('.', ',');
};

export const totalUpt = ({ rows }) => {
  const total_pieces = rows.reduce(
    (acc, i) =>
      parseFloat(i.pieces.replace ? i.pieces.replace(',', '.') : i.pieces) +
      acc,
    0,
  );
  const total_receipts = rows.reduce(
    (acc, i) =>
      parseFloat(
        i.receipts.replace ? i.receipts.replace(',', '.') : i.receipts,
      ) + acc,
    0,
  );
  let upt = 0;
  if (total_pieces > 0 && total_receipts > 0) {
    upt = total_pieces / total_receipts;
  }
  upt = upt.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  return upt.replace('.', ',');
};

export const totalTaxes = ({ rows }) => {
  let total_taxable = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(i.taxable.replace ? i.taxable.replace(',', '.') : i.taxable),
    0,
  );
  let total_taxable_vat = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(
        i.taxable_vat.replace ? i.taxable_vat.replace(',', '.') : i.taxable_vat,
      ),
    0,
  );

  total_taxable = total_taxable.toString().match(/^-?\d+(?:\.\d{0,2})?/)
    ? total_taxable.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    : '';
  total_taxable_vat = total_taxable_vat.toString().match(/^-?\d+(?:\.\d{0,2})?/)
    ? total_taxable_vat.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    : '';

  return {
    total_taxable: total_taxable.replace('.', ','),
    total_taxable_vat: total_taxable_vat.replace('.', ','),
  };
};

export const totalConv = ({ rows }) => {
  const total_receipts = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(
        i.receipts.replace ? i.receipts.replace(',', '.') : i.receipts,
      ),
    0,
  );
  const total_visitors = rows.reduce(
    (acc, i) =>
      acc +
      parseFloat(
        i.visitors.replace ? i.visitors.replace(',', '.') : i.visitors,
      ),
    0,
  );
  let conv = 0;
  if (total_receipts > 0 && total_visitors > 0) {
    conv = total_receipts / total_visitors;
  }
  conv = conv.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

  return conv.replace('.', ',');
};

export const totalRec = ({ rows, key }) =>
  rows.reduce((acc, i) => acc + Number(i[key]), 0);

export const getTotals = (list) => {
  const data = {
    taxable: 0,
    taxable_vat: 0,
    receipts: 0,
    pieces: 0,
    visitors: 0,
    atv: 0,
    upt: 0,
    conversion_rate: 0,
  };
  const { total_taxable, total_taxable_vat } = totalTaxes({ rows: list });
  data.taxable = total_taxable;
  data.taxable_vat = total_taxable_vat;
  data.receipts = totalRec({ rows: list, key: 'receipts' });
  data.pieces = totalRec({ rows: list, key: 'pieces' });
  data.visitors = totalRec({ rows: list, key: 'visitors' });
  data.atv = totalAtv({ rows: list });
  data.upt = totalUpt({ rows: list });
  data.conversion_rate = totalConv({ rows: list });
  return data;
};
